import axios from "axios"; // Axio HTTP Request
import moment from 'moment'; // MomentJS
import HTTPRequest from './controllers/httpRequest.js'; // HTTP Request
import secureStorage from './controllers/secureStorage.js'; // Cache Storage
import store from './store/store'; //vuex

const setEnabledCategories = async() => {
    const loggedIn = secureStorage.getItem("loggedIn");
    const developerMode = secureStorage.getItem("developerMode");
    const isRippleAdmin = secureStorage.getItem("isRippleAdmin")

    if (!loggedIn || isRippleAdmin || developerMode) { return; }

    const categories = await HTTPRequest.getRequest(`${store.state.endPoint}system_module_categories/user_enabled_parent_categories`, null);

    const enabledCategories = categories.categories
    const enabledUrls = [];

    let parentCategories = []
    let addedParentCategories = []
    enabledCategories.map(category => {
        if (!addedParentCategories.includes(category.system_module_category_id)) {
            parentCategories.push({
                id: category.system_module_category_id,
                code: category.system_module_category_code,
                name: category.system_module_category_name,
            })
            addedParentCategories.push(category.system_module_category_id);
        }

        if (!enabledCategories.includes(category.endpoint)) {
            enabledUrls.push(category.endpoint)
        }
    })

    parentCategories.map((category, indx) => {
        const raw_children = enabledCategories.filter(module => module.system_module_category_id == category.id)
        parentCategories[indx].raw_children = raw_children;
    })

    store.commit('updateEnabledCategories', parentCategories)
    store.commit('updateEnabledCategoryUrls', enabledUrls)
}

const isPathPermitted = (path) => {
    // console.log(path);
    // return true;
    const loggedIn = secureStorage.getItem("loggedIn");
    const developerMode = secureStorage.getItem("developerMode");
    const isRippleAdmin = secureStorage.getItem("isRippleAdmin")

    // secureStorage.getItem("isAccountOwner"),

    if (!loggedIn || isRippleAdmin || developerMode) { return true; }

    const validPaths = [...store.state.enabledCategoryUrls, '/dashboard', '/jobs','/landing_page']
        // console.log(validPaths);

    if (validPaths.includes(path)) {
        // Checker for all enabled categories for current user
        return true;
    } else if (path.includes('/document_form')) {
        // Check if path is /document_form and if user has a /documents or /products_v2 permission
        const specialPaths = validPaths.filter(url => url.includes('/documents') || url.includes('/products_v2'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/children_products')) {
        // Check if path is /children_products and if user has a /documents permission
        const specialPaths = validPaths.filter(url => url.includes('/documents'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/advanced_promotions')) {
        // Check if path is /advanced_promotions and if user has a /promotions_dashboard permission
        const specialPaths = validPaths.filter(url => url.includes('/promotions_dashboard'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/product_updates') || path.includes('/products_v2')) {
        // Check if path is /product_updates and if user has a /products_v2 permission
        const specialPaths = validPaths.filter(url => url.includes('/products_v2'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/pos_document_form')) {
        // Check if path is /pos_document_form and if user has a /pos_documents permission
        const specialPaths = validPaths.filter(url => url.includes('/pos_documents'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/online_stores')) {
        // Check if path is /online_stores and if user has a /online_stores permission
        const specialPaths = validPaths.filter(url => url.includes('/online_stores'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/pos_session_details')) {
        // Check if path is /pos_session_details and if user has a /pos_session_details permission
        const specialPaths = validPaths.filter(url => url.includes('/pos_session_details') || url.includes('/tools'))
        if (specialPaths.length > 0) { return true; }
    }

    return false;
}

const sortAlphabetical = (arr, key) => {
  let feedback = arr.sort((a, b) => {
    const textA = a[key].toUpperCase();
    const textB = b[key].toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  });

  return feedback;
}

const compareData = (from, to) => {
    var diff = function (obj1, obj2) {

        // Make sure an object to compare is provided
        if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
            return obj1;
        }

        // Variables

        var diffs = {};
        var key;

        // Methods

        /**
        * Check if two arrays are equal
        * @param  {Array}   arr1 The first array
        * @param  {Array}   arr2 The second array
        * @return {Boolean}      If true, both arrays are equal
        */
        var arraysMatch = function (arr1, arr2) {

            // Check if the arrays are the same length
            if (arr1.length !== arr2.length) return false;

            // Check if all items exist and are in the same order
            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i.substring(1)]) return false;
            }

            // Otherwise, return true
            return true;

        };

        /**
        * Compare two items and push non-matches to object
        * @param  {*}      item1 The first item
        * @param  {*}      item2 The second item
        * @param  {String} key   The key in our object
        */
        var compare = function (item1, item2, key) {

            // Get the object type
            var type1 = Object.prototype.toString.call(item1);
            var type2 = Object.prototype.toString.call(item2);

            // If type2 is undefined it has been removed
            if (type2 === '[object Undefined]') {
                diffs[key] = null;
                return;
            }

            // If items are different types
            if (type1 !== type2) {
                diffs[key] = item2;
                return;
            }

            // If an object, compare recursively
            if (type1 === '[object Object]') {
                var objDiff = diff(item1, item2);
                if (Object.keys(objDiff).length > 0) {
                    diffs[key] = objDiff;
                }
                return;
            }

            // If an array, compare
            if (type1 === '[object Array]') {
                if (!arraysMatch(item1, item2)) {
                    diffs[key] = item2;
                }
                return;
            }

            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (type1 === '[object Function]') {
                if (item1.toString() !== item2.toString()) {
                    diffs[key] = item2;
                }
            } else {
                if (item1 !== item2 ) {
                    diffs[key] = item2;
                }
            }

        };


        //
        // Compare our objects
        //

        // Loop through the first object
        for (key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                compare(obj1[key], obj2[key.substring(1)], key);
            }
        }

        // Loop through the second object and find missing items
        for (key in obj2) {
            if (obj2.hasOwnProperty(key)) {
                if (!obj1[key] && obj1[key] !== obj2[key.substring(1)] ) {
                    diffs[key] = obj2[key.substring(1)];
                }
            }
        }

        // Return the object of differences
        return diffs;

    };

    return diff(from, to);
}

const uploadToS3 = async function(file, profile) {
  const accountName = secureStorage.getItem("accountName");

  const uploaderEndpoint = await HTTPRequest.getRequest(`${store.state.endPoint}settings/api_s3_uploader`, null, null) || {}

  if (!uploaderEndpoint.endpoint) { return { error: 'No S3 endpoint' } }

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  let fileResponse;
  await axios({
    method: 'POST',
    url: `${uploaderEndpoint.endpoint}?profile=${profile}&account_name=${accountName}`,
    headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
    // Uncomment for Testing. Note: get user token in Staging
    // headers: {'Authorization': 'Bearer ' + 'paste_user_token'},
    
    data : fileFormData
  })
  .then(function (response) {
    fileResponse = response.data
  })
  .catch(function (error) {
    fileResponse = { error: error }
    //console.log(error)
  });

  return fileResponse;
}

const objectToFormData = (form, obj, parentKey=null, isParentArray=false) => {
  for (const [key, value] of Object.entries(obj)) {
    if ([null, undefined].includes(value)) { continue; }
    if (typeof value === 'object' && !Array.isArray(value)) {
      // Object
      let newKey = parentKey ? `${parentKey}[${key}]` : key;
      newKey = isParentArray ? `${parentKey}[]` : newKey;
      if (value instanceof moment) {
        form.append(newKey, value.toDate());
      } else {
        objectToFormData(form, value, newKey);
      }
    } else if (typeof value === 'object' && Array.isArray(value)) {
      // Array
      let newKey = parentKey ? `${parentKey}[${key}]` : key;
      newKey = isParentArray ? `${parentKey}[]` : newKey;
      if (value instanceof moment) {
        form.append(newKey, value.toDate());
      } else {
        objectToFormData(form, value, newKey, true);
      }
    } else if (parentKey) {
      // Other with parentKey
      const newKey = isParentArray ? `${parentKey}[]` : `${parentKey}[${key}]`;
      form.append(newKey, value);
    } else {
      // Other
      form.append(key, value);
    }
  }
}

const formatStatus = (value) => {
    switch (value) {
      case 'A':
        return 'Active'
      case 'I':
        return 'Inactive'
      case 'D':
        return 'Disabled'
      default:
        return value
    }
  }

const compareJsonObject = (from, to, currentObj) => {
    var arrayUnique = function(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
  
      return a;
  }
    var diff = function (obj1, obj2) {
      const obj = currentObj || []
      const result = {};
      if (Object.is(obj1, obj2)) {
          return undefined;
      }
      if (!obj2 || typeof obj2 !== 'object') {
          return obj2;
      }
      arrayUnique(Object.keys(obj1 || {}).concat(Object.keys(obj2 || {}))).forEach(key => {
          if(obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
              result[key] = obj2[key];
              var index = obj.findIndex(n => n.key == key)
              if (index > -1){
                  if(obj[index]['old_value'] == obj2[key]){
                    obj.splice(index,1)
                  }else{
                    obj[index] = {key:key,old_value:obj1[key],new_value:obj2[key]}
                  }
              }else{
                obj.push({key:key,old_value:obj1[key],new_value:obj2[key]})
              }
          }
          if(typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
              const value = diff(obj1[key], obj2[key]);
              if (value !== undefined) {
                  result[key] = value;
              }
          }
      });
      return obj;
    }
    return diff(from, to);
}

// const dissectReportFilters = (parameters, displayOptions, formatOptions) => {
//   let parameterKeys = Object.keys(parameters)
//   let advanceFilters = parameters.advanced_filter
//   let productFilterKeys = Object.keys(advanceFilters)
//   let basicFilters = {}
//   let filterLabels = {}

//   parameterKeys.forEach((key) => {
//     let currentKey;
//     switch (key) {
//       case 'isFormat':
//         currentKey = parameters[key]
//         basicFilters['format'] = formatOptions.filter(({ key }) => key == currentKey)[0].value
//         break;

//       case 'group':
//         basicFilters['group_by'] = parameters[key].split("_")[0]
//         break;

//       case 'order':
//         basicFilters['sort_by'] = parameters[key].split("_")[0]
//         break;

//       case 'by':
//         basicFilters['sort_by'] = `${basicFilters['sort_by']}(${(_.upperCase(parameters[key]))})`
//         break;

//       case 'display':
//         currentKey = parameters[key]
//         basicFilters['display'] = displayOptions.filter(({ key }) => key == currentKey)[0].value
//         break;
//     }
//   })

//   let filterKeys = Object.keys(basicFilters)
//   let productFilters = productFilterKeys.filter((key) => ((advanceFilters[key] !== null) && (advanceFilters[key].length !== 0))).map((fKey) => {
//     if (fKey.includes('_id')) {
//       fKey = fKey.replace('_id', '')
//     }
//     fKey = _.capitalize(fKey.split('_').join(" "))
//     return fKey
//   })
//   filterLabels['basic'] = filterKeys.map((key) => `${_.capitalize(key.replace("_", " "))}: ${basicFilters[key]}`).join(", ")
//   filterLabels['advance'] = productFilters.join(", ")
//   return filterLabels
// }
const formatProductCategories = (value) => {
    let formatedProductCategory = String(value);
    return formatedProductCategory
  }

export {
  compareData, compareJsonObject,
  formatProductCategories, formatStatus, isPathPermitted, objectToFormData, setEnabledCategories, sortAlphabetical, uploadToS3
};

